import { render, staticRenderFns } from "./choose-contact.vue?vue&type=template&id=dffbf8d8&scoped=true&"
import script from "./choose-contact.vue?vue&type=script&lang=js&"
export * from "./choose-contact.vue?vue&type=script&lang=js&"
import style0 from "./choose-contact.vue?vue&type=style&index=0&id=dffbf8d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dffbf8d8",
  null
  
)

export default component.exports